import React from 'react'
import { hot } from 'react-hot-loader';
import { Link } from 'react-router-dom';

import { folderContentsUrl } from '../../../urls';

const ExperimentRootItems = ({ experiment, files }) => {

  const li_list = files.map((file) => {
    return (
      // <li key={file.id}>
        // <Link to={folderContentsUrl(experiment.fiscal_year, file.experiment_id, file.id)}>{file.name}</Link>
      // </li>
        <>
          <a href={folderContentsUrl(experiment.fiscal_year, file.experiment_id, file.id)} className="w-75 list-group-item list-group-item-action list-group-item-success">{file.name}</a>
        </>

        );
  });

        return (
        <ul className="list-group">
          {li_list}
        </ul>
        );
};

        export default hot(module)(ExperimentRootItems);
